import { apiClient } from '@/utils/api'

export interface LLMPreference {
  provider: string
  model: string
}

class LLMPreferenceService {
  async getPreference(): Promise<LLMPreference | null> {
    try {
      const res = await apiClient.get<{ preference: LLMPreference | null }>('/aie/llm-preference')
      return res.preference
    } catch {
      return null
    }
  }

  async savePreference(provider: string, model: string): Promise<void> {
    await apiClient.put<{ preference: LLMPreference }>(
      '/aie/llm-preference',
      { provider, model },
    )
  }
}

export const llmPreferenceService = new LLMPreferenceService()
